import React, { Suspense } from "react";
import {
  Card,
  Box,
  Grid,
  Tabs,
  Tab,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import UserList from "../components/user/UserList";
import "../styles/user.css";
import { Route, Routes } from "react-router-dom";
import User from "../routes/User";
import UserStats from "../components/user/UserStats";
import UnassignedUserList from "../components/user/UnassignedUserList";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateUserTile from "../components/user/CreateUserTile";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";

const t = {
  pageBg: "#f3f0f9",
  cardBg: "#ffffff",
  border: "#e0daf0",
  borderHover: "#a89cd4",
  accent: "#6c5ce7",
  accentLight: "#f0edfd",
  accentMid: "#ece8fb",
  inputBg: "#faf9fd",
  textPrimary: "#1a1a2e",
  textSecondary: "#6b6b80",
  textMuted: "#a0a0b0",
  radius: "12px",
  radiusSm: "8px",
  radiusXs: "6px",
};

const cardSx = {
  background: t.cardBg,
  border: `0.5px solid ${t.border}`,
  borderRadius: t.radius,
  boxShadow: "none",
};

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Users = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Routes>
      <Route
        path="/"
        exact
        element={
          <Box
            className="fragmentContainer"
            sx={{ p: 3, background: t.pageBg, minHeight: "100vh" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2.5,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PeopleAltOutlinedIcon sx={{ color: t.accent, fontSize: 22 }} />
                <Typography
                  sx={{ fontSize: "18px", fontWeight: 500, color: t.textPrimary }}
                >
                  Users
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "12px", color: t.textMuted }}>
                Updated just now
              </Typography>
            </Box>

            <Grid
              container
              spacing={2}
              sx={{ mb: 2 }}
            >
              {/* Stat card */}
              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <Suspense fallback={<StatSkeleton />}>
                  <UserStats
                    cardSx={cardSx}
                    accent={t.accent}
                    accentLight={t.accentLight}
                    textPrimary={t.textPrimary}
                    textSecondary={t.textSecondary}
                  />
                </Suspense>
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                <CreateUserTile
                  cardSx={cardSx}
                  accent={t.accent}
                  accentLight={t.accentLight}
                />
              </Grid>
            </Grid>

            <Card variant="outlined" sx={cardSx}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2,
                  pt: 1,
                  borderBottom: `0.5px solid ${t.border}`,
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  sx={{
                    minHeight: "42px",
                    "& .MuiTabs-indicator": {
                      backgroundColor: t.accent,
                      height: "2px",
                      borderRadius: "2px 2px 0 0",
                    },
                    "& .MuiTab-root": {
                      minHeight: "42px",
                      textTransform: "none",
                      fontSize: "13px",
                      fontWeight: 500,
                      color: t.textSecondary,
                      px: 2,
                      gap: 1,
                      "&.Mui-selected": {
                        color: t.accent,
                        fontWeight: 600,
                      },
                    },
                  }}
                >
                  <Tab
                    icon={<GroupOutlinedIcon sx={{ fontSize: 16 }} />}
                    iconPosition="start"
                    label={`${localStorage.selectedCustomer || "Visteon"} Users`}
                    {...a11yProps(0)}
                  />
                  <Tab
                    icon={<PersonOffOutlinedIcon sx={{ fontSize: 16 }} />}
                    iconPosition="start"
                    label="Unassigned Users"
                    {...a11yProps(1)}
                  />
                </Tabs>
              </Box>

              <div className="tabs-container">
                <CustomTabPanel value={value} index={0}>
                  <UserList {...props} />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <UnassignedUserList {...props} />
                </CustomTabPanel>
              </div>
            </Card>
          </Box>
        }
      />
      <Route path="/:userId/*" element={<User />} />
    </Routes>
  );
};

export default Users;